import React from 'react';
import "./PRDetailHero.scss";
import motif from "../../assets/motiff.png"
import OpenGraphTag from "../../library/baaShared/OpenGraphTag";

export default function PRDetailHero(props) {

  let image
  let title
  let tagLine
  let yearTitle
  if (props) {
    image = props.fields && props.fields["Hero Image"] && props.fields["Hero Image"].value && props.fields["Hero Image"].value.src
    title = props.fields && props.fields.Title && props.fields.Title.value
    tagLine = props.fields && props.fields.Tagline && props.fields.Tagline.value
    yearTitle = props.fields && props.fields["Year Title"] && props.fields["Year Title"].value
  }

  return (
    <>
    <OpenGraphTag image={image} title={title} description={tagLine}/>
    <div>
      <div className="PRDetail-hero-area" style={{ backgroundImage: `url(${image})` }}>
        <div className="center-gradient" ></div>
        <div className="center-gradient"></div>
        <div className="PRDetail-hero-area-text">
          <div  className="PRDetailTitle">
            <span>{yearTitle} </span>
          </div>
          <div class="PRDetailTagline">
            <h1>
            {title}
          </h1>
          </div>
          <div className="PRDetailDescription">
            <p>
            {tagLine}
          </p>
          </div>
          
        </div>
        {/* <div className="motif-below" style={{ backgroundImage: `url(${motif})` }} /> */}
      </div>
    </div>
    </>
  );
}
